import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'

import instance from '@/services/request/interceptors.api'

export const request = async <T>(config: AxiosRequestConfig) => {
	const onSuccess = (response: AxiosResponse<T>) => response.data

	const onError = (error: unknown) => {
		if (error instanceof Error && 'response' in error) {
			const axiosError = error as AxiosError
			if (axiosError.response?.status !== 404) {
				console.error('Request error: ', error)
			}
		} else {
			console.error('Request error: ', error)
		}

		return Promise.reject(error)
	}

	return instance(config).then(onSuccess).catch(onError)
}
